// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_au-2";
export var aiChatCartContainerExit = "_au-4";
export var aiChatContainerLarge = "_au-0";
export var aiChatContainerSmall = "_au-1";
export var aiChatIcon = "_au-6";
export var slideInFromRight = "_au-3";
export var slideOutToRight = "_au-5";